import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-clay/40 bg-void text-white/60">
      <div className="container-editorial grid gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-1">
          <Logo light />
          <p className="mt-4 max-w-xs text-[14px] leading-relaxed text-white/50">
            Local inventory. Personal delivery.<br />London, Ontario.
          </p>
        </div>

        <FootCol title="Shop">
          <Link to="/shop" className="text-white/60 link-underline hover:text-white">Shop All</Link>
          <Link to="/shop?gender=men" className="text-white/60 link-underline hover:text-white">Men's</Link>
          <Link to="/shop?gender=women" className="text-white/60 link-underline hover:text-white">Women's</Link>
          <Link to="/brands" className="text-white/60 link-underline hover:text-white">Brands</Link>
        </FootCol>

        <FootCol title="Info">
          <Link to="/how-it-works" className="text-white/60 link-underline hover:text-white">How It Works</Link>
          <Link to="/about" className="text-white/60 link-underline hover:text-white">About</Link>
          <Link to="/faq" className="text-white/60 link-underline hover:text-white">FAQ</Link>
          <Link to="/sell" className="text-white/60 link-underline hover:text-white">Sell to us</Link>
        </FootCol>

        <FootCol title="Connect">
          <Link to="/contact" className="text-white/60 link-underline hover:text-white">Message me</Link>
          <Link to="/alerts" className="text-white/60 link-underline hover:text-white">Join the drop list</Link>
          <a href="https://instagram.com/theclothingplug.ldn" target="_blank" rel="noopener noreferrer" className="text-white/60 link-underline hover:text-white">Instagram</a>
          <a href="sms:5196303565" className="text-white/60 link-underline hover:text-white">Text / iMessage</a>
        </FootCol>
      </div>

      <div className="border-t border-white/10">
        <div className="container-editorial flex flex-wrap items-center justify-between gap-3 py-5 text-[13px] text-white/40">
          <span>© {new Date().getFullYear()} The Clothing Plug · London, Ontario</span>
          <span className="flex items-center gap-4">
            <span>If it's listed, it's available unless marked reserved or sold.</span>
            <Link to="/admin" className="text-white/30 link-underline hover:text-white/70">Owner sign-in</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

function FootCol({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <p className="text-[12px] font-bold uppercase tracking-[0.12em] text-white/40 mb-3">{title}</p>
      <div className="flex flex-col gap-2 text-[14px]">{children}</div>
    </div>
  );
}
